module.exports = "/images/it.svg";